
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"48","viewBox":"0 96 960 960","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M102 794q-9-9-8.5-21t8.5-21l249-249q5-5 10-7t11-2q6 0 11 2t10 7l146 146 241-241h-97q-13 0-21.5-8.5T653 378q0-13 8.5-21.5T683 348h167q13 0 21.5 8.5T880 378v167q0 12-8.5 21t-20.5 9q-12 0-21-9t-9-21v-93L559 714q-5 5-10 7t-11 2q-6 0-11-2t-10-7L371 568 144 795q-8 8-20.5 8t-21.5-9z"}})])
          )
        }
      }
    